
import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import {
  GET_VENDOR_PROFILE_FAILURE,
  GET_VENDOR_PROFILE_SUCCESS,
  GET_VENDOR_PROFILE_REQUEST,
  UPDATE_VENDOR_PROFILE_REQUEST,
  UPDATE_VENDOR_PROFILE_FAILURE,
  UPDATE_VENDOR_PROFILE_SUCCESS
} from "./ActionType";

export const getVendorProfile = () => async (dispatch) => {
  dispatch({ type: GET_VENDOR_PROFILE_REQUEST });
  try {
    const { data } = await privateAxios.get(`vendor/vendor/profile`);
    dispatch({ type: GET_VENDOR_PROFILE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_VENDOR_PROFILE_FAILURE,
      payload: error.message
    });
  }
}

export const updateProfile = (profileId, profileData, setOpenModal) => async (dispatch) => {
  dispatch({ type: UPDATE_VENDOR_PROFILE_REQUEST })
  try {
    const { data } = await privateAxios.put(`vendor/vendor/${profileId}`, profileData);
    if (data.status === "SUCCESS") {
      dispatch(getVendorProfile())
      dispatch({ type: UPDATE_VENDOR_PROFILE_SUCCESS, payload: data })
      toast.success("Profile updated !!")
      setOpenModal(false)
    } else {
      toast.error(data?.response || "Failed to Update Profile.");
    }

  } catch (error) {
    toast.error(error?.response?.data?.response || "An error occurred while Updating Profile.")
    dispatch({ type: UPDATE_VENDOR_PROFILE_FAILURE, payload: error.message })
  }
}
